// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"NotFoundContent_errorPageWrapper__2amV3","errorPageContentWrap":"NotFoundContent_errorPageContentWrap__la8MZ"};